import { useState } from 'react';
import { Project, Staff } from '../../../types';

export function useProjectForm(project: Project) {
  const [editedProject, setEditedProject] = useState(project);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const toggleTag = (tag: any) => {
    setEditedProject(prev => {
      const hasTag = prev.tags.some(t => t.id === tag.id);
      return {
        ...prev,
        tags: hasTag
          ? prev.tags.filter(t => t.id !== tag.id)
          : [...prev.tags, tag]
      };
    });
  };

  const toggleStaff = (member: Staff) => {
    setEditedProject(prev => {
      const hasStaff = prev.staff.some(s => s.id === member.id);
      return {
        ...prev,
        staff: hasStaff
          ? prev.staff.filter(s => s.id !== member.id)
          : [...prev.staff, member]
      };
    });
  };

  const formatBudget = (value: string) => {
    const numericValue = value.replace(/[^0-9]/g, '');
    if (numericValue) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(parseInt(numericValue, 10));
    }
    return '';
  };

  return {
    editedProject,
    setEditedProject,
    showDeleteConfirm,
    setShowDeleteConfirm,
    toggleTag,
    toggleStaff,
    formatBudget
  };
}